import request from '@/router/axios';

/**
 * 发布课堂公告
 * @param {Object} data
 * @param {String} data.content 内容
 * @param {String} data.lessonUid 课堂uid
 * @param {String} data.title 标题
 */
export const addLabLessonNotice = data => {
    return request('/api/lab/lablessonnotice', { data }, 'post');
};

/**
 * 批量删除公告
 * @param {Array} data 公告的uid集合
 */
export const removeLabLessonNotices = data => {
    return request('/api/lab/lablessonnotice/deleteBatchByUid', { data }, 'delete');
};

/**
 * 编辑课堂公告
 * @param {Object} data
 * @param {String} data.content 内容
 * @param {String} data.lessonUid 课堂uid
 * @param {String} data.title 标题
 */
export const updateLabLessonNotice = data => {
    return request('/api/lab/lablessonnotice', { data }, 'put');
};

/**
 * 分页查询公告列表
 * @param {Number} page 当前页码
 * @param {Number} limit 每页条数
 * @param {Object} params 其他参数
 * @param {String} params.lessonUid 课堂uid
 */
export const getLabLessonNoticesByPage = (page, limit, params) => {
    return request('/api/lab/lablessonnotice/query', {
        params: {
            ...params,
            page,
            limit
        }
    });
};
